import { instance } from 'src/apis/index';

export const apiPost = {
  getNoticeList: (festivalId: number, type: string) =>
    instance.get(`notice/${festivalId}`, { params: { type } }),

  getNoticeDetail: (festivalId: number, noticeId: number) =>
    instance.get(`notice/${festivalId}/${noticeId}`),
};
